import { Injectable } from "@angular/core";
import { EventType } from "../../../crossconcern/types/event.type";
import { Observable } from "rxjs";
import { LogList } from "../../entities/loglist.model";

@Injectable()
export abstract class LogRepositoryInterface {

    public abstract addEvent(event: EventType): Observable<{}>;
    public abstract getLogs(size: number, page: number): Observable<LogList>;
}